export function formatTimeFrom(
  timestamp: number,
  style: Intl.RelativeTimeFormatStyle,
  daysOnly?: boolean
): string | undefined {
  const formatter = new Intl.RelativeTimeFormat('pt-BR', {
    numeric: 'auto',
    style
  });

  const DIVISIONS = [
    { amount: 60, name: 'seconds' },
    { amount: 60, name: 'minutes' },
    { amount: 24, name: 'hours' },
    { amount: 7, name: 'days' },
    { amount: 4.34524, name: 'weeks' },
    { amount: 12, name: 'months' },
    { amount: Number.POSITIVE_INFINITY, name: 'years' }
  ];

  const currentTime = new Date();
  let duration = (timestamp - currentTime.getTime()) / 1000;

  if (daysOnly) {
    duration = duration / (60 * 60 * 24);
    return formatter.format(Math.round(duration), 'days');
  }

  for (const iterator of DIVISIONS) {
    if (Math.abs(duration) < iterator.amount) {
      return formatter.format(Math.round(duration), iterator.name as Intl.RelativeTimeFormatUnit);
    }
    duration /= iterator.amount;
  }
}

export function formatToDate(
  timestamp: number,
  style?: 'medium' | 'full' | 'long' | 'short'
): string {
  const timeStamp = new Date(timestamp);
  return timeStamp.toLocaleDateString('pt-BR', {
    dateStyle: style
  });
}

export function removePlural(plural: string): string {
  const result = plural.replace(/s$/, '');
  return result;
}

export function formatPriceToReal(price: number): string {
  const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  return formatter.format(price);
}

export function formatFabricationAndModelYear(
  fabricationYear: number | undefined,
  modelYear: number | undefined
): string {
  if (!fabricationYear && !modelYear) return '';
  if (!fabricationYear && modelYear) return String(modelYear);
  if (!modelYear && fabricationYear) return String(fabricationYear);

  if (fabricationYear === modelYear) {
    return String(fabricationYear);
  }

  return `${fabricationYear}/${modelYear}`;
}

export function formatPlate(plate: string): string {
  const firstHalf = plate.substring(0, 3);
  const secondHalf = plate.substring(3, plate.length);
  return `${firstHalf}-${secondHalf}`;
}

export function formatNumber(number?: number): string | null {
  if (!number) {
    return null;
  }

  const formatter = new Intl.NumberFormat('pt-BR', {
    unit: 'kilometer',
    style: 'unit'
  });

  return formatter.format(number);
}
